import { fetchApi } from "../components/FetchApi";
import { wrapServiceCall } from "./ServiceUtils";

export const getUserFavorites = ({ page = 0 } = {}) =>
  wrapServiceCall(() => fetchApi(`/users/favorite?page=${page}`, { method: "GET" }));

export const addFavorite = (listingId) =>
  wrapServiceCall(() => fetchApi(`/users/favorite/${listingId}`, { method: "POST" }), { skipNotify: true });

export const removeFavorite = (favoriteId) =>
  wrapServiceCall(
    () => fetchApi(`/users/favorite/${favoriteId}/remove`, { method: "DELETE" }),
    { skipNotify: true }
  );

/** Toggle favorite - add if not favorited, remove if favorited. Returns { favorited, favoriteId }. */
export const toggleFavorite = (listingId) =>
  wrapServiceCall(
    () => fetchApi(`/users/favorite/${listingId}/toggle`, { method: "POST" }),
    { skipNotify: true }
  );

export const getGoogleLinkStatus = () =>
  wrapServiceCall(() => fetchApi("/users/google-linked", { method: "GET" }));

export const linkGoogleAccount = (googleId) =>
  wrapServiceCall(() =>
    fetchApi("/users/link-google", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ googleId }),
    })
  );

export const unlinkGoogleAccount = () =>
  wrapServiceCall(() => fetchApi("/users/unlink-google", { method: "POST" }));

export const changePassword = ({ oldPassword, newPassword }) =>
  wrapServiceCall(() =>
    fetchApi("/users/password", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ oldPassword, newPassword }),
    })
  );

export const deleteAccount = () =>
  wrapServiceCall(() => fetchApi("/users/account", { method: "DELETE" }));
